import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const AuditLog = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M13 7.5h8a1 1 0 1 0 0-2h-8a1 1 0 0 0 0 2zM21 16h-8a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zM7.872 13H4.128A2.13 2.13 0 0 0 2 15.128v3.744A2.13 2.13 0 0 0 4.128 21h3.744A2.13 2.13 0 0 0 10 18.872v-3.744A2.13 2.13 0 0 0 7.872 13zM8 18.872c0 .07-.058.128-.128.128H4.128A.128.128 0 0 1 4 18.872v-3.744c0-.07.058-.128.128-.128h3.744c.07 0 .128.058.128.128v3.744zM2.293 9.707a.997.997 0 0 0 1.414 0L5.5 7.914l1.793 1.793a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L6.914 6.5l1.793-1.793a1 1 0 1 0-1.414-1.414L5.5 5.086 3.707 3.293a1 1 0 1 0-1.414 1.414L4.086 6.5 2.293 8.293a1 1 0 0 0 0 1.414z" />
  </SvgIcon>
);

export default AuditLog;
